<template>
  <v-dialog v-model="dialog" max-width="600px" persistent scrollable>
    <v-card flat v-if="message">
      <v-card-title class="pa-1 pb-0 px-3">
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon color="primary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-img src="images/notification/xxx3.jpg" aspect-ratio="7.7"></v-img>
      </v-card-text>
      <v-card-text class="py-2">
        <v-row class="ma-0 px-0 py-0">
          <v-col cols="6" class="text-h6 ma-0 pa-0" style="color:black">{{item.nome}}</v-col>
          <v-col cols="6" class="text-right ma-0 pa-0">{{ item.data_publicacao | formatDate}}
            <span class="warning--text" v-if="item.prioridade_alta">
            <v-icon color="warning" small class="ml-2 mr-1">fa-bookmark</v-icon>Alta importância</span>
            <br />
            <span class="module-text">{{modulosTitles[item.modulo]}}</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-html="item.mensagem">
      </v-card-text>
      <v-card-actions class="px-5 pt-0 pb-4">
        <v-spacer v-if="!(updatenotification && !item.automatica)"></v-spacer>
        <v-btn outlined small height="30px" color="primary" @click="close">Fechar</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="updatenotification && !item.automatica" depressed small height="30px" color="primary" @click="selectItem(item)">Editar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
moment.locale('pt-BR')
import { mapState } from 'vuex'
export default {
  props: {
    dialog: Boolean,
    close:Function,
    updatenotification: Boolean,
    message: String,
    markAsReaded: Function,
    modulosTitles: Object,
    selectItem: Function
  },
  data() {
    return {
      item: null
    };
  },
  watch: {
    message(val) {
      if(!val) return
      this.item = JSON.parse(val)
      let messageId = this.item.id
      if(!this.item.is_readed){
        setTimeout( () => { 
          if(this.item.id == messageId){
            this.markAsReaded(this.item)
          }
        }, 3000);
      }
      this.$nextTick()
    },
    dialog(val){
      if(val){
         setTimeout( () => { 
            let linkRecursos =  document.querySelector('a.setfilter')
            if(linkRecursos){
              linkRecursos.addEventListener("click", (e) => {
                    e.preventDefault();
                    let [grupo_economico, operadora_ans_id, prestador_id, data_pagamento] = linkRecursos.getAttribute('parametros').split(',')
                    if(!!grupo_economico && !!operadora_ans_id && !!prestador_id && !!data_pagamento){
                      this.setFilter(Number(grupo_economico), Number(operadora_ans_id), Number(prestador_id), data_pagamento);
                    }
                  });
            }
            let linkFaturamento = document.querySelector('a.redirfaturamento')
             if(linkFaturamento) {
                linkFaturamento.addEventListener("click", (e) => {
                    e.preventDefault();
                    let grupo_economico = Number(linkFaturamento.getAttribute('parametros'))
                    let url = linkFaturamento.getAttribute('href')
                    this.redirectFaturamento(grupo_economico, url)
                })
             }
         }, 600)
      } else {
        let linkRecursos = document.querySelector('a.setfilter')
        let linkFaturamento = document.querySelector('a.redirfaturamento')
        if(linkRecursos){ linkRecursos.removeEventListener("click", this) }
        if(linkFaturamento){ linkFaturamento.removeEventListener("click", this) }
      }
    }
  },
  filters:{
    formatDate(date) {
      let dateString = moment(date).calendar();
      if(dateString.indexOf('às')> 0){
        dateString = dateString.split(' às')[0]
      }
      return dateString
    }
  },
  computed: {
    ...mapState({
      userData: (state) => state.userData.userData,
      grupoEconomico: (state) => state.permissions.grupoEconomico
    }),
  },
  methods: {
    redirectFaturamento(grupo_economico, url){
      grupo_economico = 29
      url = '/faturamento/cronogramas/dadosdocronograma/20210510100000008'
      if(grupo_economico != this.grupoEconomico){
        this.$store.dispatch('permissions/changeGrupoEconomico', grupo_economico).then(()=>  this.$router.push(url) )
      } else {    
        this.$router.push(url)
      }

    },
    setFilter(grupo_economico, operadora_ans_id, prestador_id, data_pagamento){
      prestador_id = [prestador_id];
      operadora_ans_id = [operadora_ans_id];
      let filter = {
          filterData: {
           grupo_economico,
           operadora_ans_id,
           prestador_id,
           carteira: null,
           owner_id: null,
           etapa: null,
           data_entre: data_pagamento.replace(/['\s]/g, ""),
           data_ate: data_pagamento.replace(/['\s]/g, ""),
          },
          filterName: 'recursosGlosaFilter',
          redirect: true
        }
      if(grupo_economico != this.grupoEconomico){
        this.$store.dispatch('permissions/changeGrupoEconomico', grupo_economico).then(()=> this.$store.commit('recebiveis/setFilter', filter, { root:true }))
      } else {    
        this.$store.commit('recebiveis/setFilter', filter, { root:true })
      }
    }
  },
};
</script>

<style>
.module-text {
  color: #4a4a4a;
  font-weight: 400;
}
</style>